









import {Component, Vue} from 'vue-property-decorator';
import {SecurityUtils} from '@/oauth/SecurityUtils';

@Component({
  components: {},
})
export default class PreviewNotPass extends Vue {

  logout() {
    SecurityUtils.logout();
  }

  private mounted() {
    return;
  }
}

